import React from "react";

import { siteConfig } from "../../constants";

import * as Styled from "./index.styled";

export function SeoContent() {
  return (
    <Styled.Container aria-labelledby="about-swiftle">
      <Styled.Section>
        <Styled.Kicker>Daily music quiz</Styled.Kicker>
        <h2 id="about-swiftle">Play Swiftle, the Taylor Swift song game</h2>
        <p>
          Swiftle is a daily Taylor Swift song guessing game for fans who know
          the bridges, intros, vault tracks, singles, and deep cuts. Hear a
          short clip, make a guess, and unlock a little more audio after each
          missed or skipped try.
        </p>
      </Styled.Section>

      <Styled.Section>
        <h2>How to play Swiftle</h2>
        <Styled.StepList>
          {siteConfig.howToSteps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </Styled.StepList>
      </Styled.Section>

      <Styled.Section>
        <h2>Why Taylor Swift fans play daily</h2>
        <p>
          The game is built for fast daily play: one mystery song, six chances,
          and a shareable result when you solve it. It works well as a quick
          Taylor Swift quiz, a Heardle-style music game, or a challenge to send
          to friends after you finish the daily puzzle.
        </p>
      </Styled.Section>

      <Styled.Section>
        <h2>Swiftle FAQ</h2>
        <Styled.FaqList>
          {siteConfig.faqs.map((item) => (
            <details key={item.question}>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </Styled.FaqList>
      </Styled.Section>
    </Styled.Container>
  );
}
